import axios from'src/utils/axios';
import { URLS } from 'src/utils/url';

class ActivityPlanService {

	create(params) {
		return axios.post(URLS.ACTIVITY_PLAN, params);
	}

	read(id) {
		return axios.get(`${URLS.ACTIVITY_PLAN}/${id}`)
	}

	update(id, params) {
		return axios.put(`${URLS.ACTIVITY_PLAN}/${id}`, params);
	}

	delete(id) {
		return axios.delete(`${URLS.ACTIVITY_PLAN}/${id}`);
	}

	search(params) {
		return axios.get(URLS.ACTIVITY_PLAN, { params: params });
	}
}

const activityPlanService = new ActivityPlanService();

export default activityPlanService;